import { useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import { useProductAttributeStates } from './state/useProductAttributeStates';
import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash-es';

export const useLinkStateToDraftProductMetadata = (attributeStates: ReturnType<typeof useProductAttributeStates>) => {
  const [draft, update] = useCustomizationContext(draft => draft.config);
  const previousState = useRef(draft.productMetadata?.selectedAttributes);
  const state = attributeStates.getFullState(draft);

  useEffect(() => {
    if (!draft.productMetadata) {
      update(draft => {
        draft.productMetadata = {
          selectedAttributes: state,
        };
      });
      previousState.current = state;
    }

    if (draft.productMetadata && !isEqual(previousState.current, state)) {
      update(draft => {
        if (draft.productMetadata) {
          draft.productMetadata.selectedAttributes = state;
        }
      });
      previousState.current = state;
    }
  }, [attributeStates, draft, draft.productMetadata, state, update]);
};
